export const SHOW_TOAST_MESSAGE_DURATION = 5000;
export const SIGN_UP_SUCCESS_MESSAGE_DURATION = 2000;
export const TOAST_FOR_ADDED_MEMBER_DURATION = 2000;
